import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import SlideShow from "../../story-templates/StoryCard/SlideShow";
import ComponentContainer from "../../layouts/component-container";
import NewsWithImage from "../../molecules/NewsWithImage";
import DfpContainer from "../../ads/dfp-container";
import { DfpComponent } from "../../ads/dfp-component";
import StoryMetaData from "../../molecules/StoryMetaData";

import { cancelablePromise, componentProps, getSlotId } from "../../utils/utils";
import { getStory } from "../../helper/api";

import "./bigPhotoStoryCardSlider1Ad.m.css";

const BigPhotoStoryCardSlider1Ad = ({ collection, lang }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const [storyElements, setStoryElements] = useState([]);

  const { items = [], autoPlay, adSlot, slideNumOpen } = componentProps(collection);

  const stories = items.filter(({ type }) => type === "story").map(({ story }) => story);

  const [firstStory, ...remainingStories] = stories;

  if (!stories.length || !remainingStories.length) {
    return null;
  }

  const { id: firstStoryId } = firstStory || {};

  useEffect(() => {
    const promise = cancelablePromise(getStory(firstStoryId));
    promise.promise
      .then(({ story }) => {
        setStoryElements(story?.cards?.flatMap((card) => card?.["story-elements"]));
      })
      .catch(console.log);

    return () => promise.cancel();
  }, []);

  return (
    <div styleName="main-wrapper">
      <ComponentContainer styleName="base" collection={collection}>
        <div styleName={`wrapper  ${adSlot ? "with-ad" : "no-ad"} `}>
          <div styleName="grid-area-1">
            {storyElements.length > 1 ? (
              <SlideShow
                isPopup={false}
                isInfinite={autoPlay}
                interval={4000}
                elements={storyElements}
                lang={lang}
                showPlayPauseBtn={true}
                hideDisableIcon={false}
                showCaptionArrow={false}
                showProgressBar={true}
                isArrow={true}
                imageClickable={true}
                story={firstStory}
                slideNumOpen={slideNumOpen}
                widths={[400, 600, 800]}
              />
            ) : (
              <CardImage
                story={firstStory}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                widths={[400, 612, 1060]}
                linkEnable={true}
              />
            )}

            <NewsHeadline story={firstStory} cssStyleName="bigSize" Htag="h2" showSponsor={false} />
            <StoryMetaData story={firstStory} />
          </div>

          {adSlot && (
            <div styleName="grid-area-2">
              <DfpContainer>
                <div styleName="side-ad" className="adsBox">
                  <DfpComponent
                    type={adSlot}
                    collectionSlug={collection.slug}
                    slotId={getSlotId(adSlot, collection.slug, "big-photostory-card-slider")}
                    layoutName="BigPhotoStoryCardSlider1Ad"
                    adsText={true}
                  />
                </div>
              </DfpContainer>
            </div>
          )}

          <div styleName="remaining-story-wrapper">
            {remainingStories.map((story) => (
              <NewsWithImage
                key={story.id}
                story={story}
                aspectRatio={[1, 1]}
                imageType="image1x1"
                widths={[200, 220, 412]}
              />
            ))}
          </div>
        </div>
      </ComponentContainer>
    </div>
  );
};

BigPhotoStoryCardSlider1Ad.propTypes = {
  collection: object,
  lang: string,
};

BigPhotoStoryCardSlider1Ad.storyLimit = 5;

const mapStateToProps = (state) => ({
  lang: state.qt.config["publisher-attributes"].lang || "bn",
});

export default connect(mapStateToProps)(BigPhotoStoryCardSlider1Ad);
